import { authFetch } from '../../utils/authFetch';

// ──────────────────────────────────────────────────────────
import {
  INITIALIZE_ASSESSMENT, SET_STEP, SET_ASSESSMENT_POSITION, SET_SECTION,
  // LEGACY - Commented out (no reducer case): FETCH_RISKS_SUCCESS, TOGGLE_SELECTED_THEME, SET_RISKS, HANDLE_SELECTED_RISKS_UPDATE, UPDATE_RISKS_AFTER_SELECTION, SAVE_SELECTED_RISKS
  FETCH_ASSESSMENT_RISKS_START, FETCH_ASSESSMENT_RISKS_FAILURE, FETCH_ASSESSMENT_RISKS_SUCCESS,
  SET_RISK_EVALUATION, SET_RISK_PRIORITY_START, SET_RISK_PRIORITY_SUCCESS, SET_RISK_PRIORITY_FAILURE, UPDATE_RISK_PRIORITY,
  UPDATE_RISK_EVALUATION, SET_MODEL_ID, SET_CURRENT_ASSESSMENT, DISCARD_RISKS,
  DISCARD_UNSAVED_RISKS, FETCH_RISKS_START, FETCH_RISKS_FAILURE, UPDATE_RISK_NAME, UPDATE_CONTROL_IN_SELECTED_RISK,
  FETCH_RISK_CARD_DATA_START, FETCH_RISK_CARD_DATA_SUCCESS, FETCH_RISK_CARD_DATA_FAILURE, FETCH_RISK_EVALUATIONS, FETCH_RISK_EVALUATIONS_SUCCESS, FETCH_RISK_EVALUATIONS_FAILURE,
  MOVE_RISK_TO_SAVED, UPDATE_SAVED_RISK, DISCARD_SAVED_RISK, RESET_RISKS_STATE,
  FETCH_SECTION_SPECIFIC_RISKS_START,
  FETCH_SECTION_SPECIFIC_RISKS_SUCCESS, FETCH_SECTION_SPECIFIC_RISKS_FAILURE, UPDATE_ASSESSMENT_STEP_SUCCESS, ASSESSMENT_STATUS_UPDATED, ASSESSMENT_STATUS_FAILED,
  REFRESH_RISKS_SUCCESS, FETCH_ASSESSMENTS_START, FETCH_ASSESSMENTS_SUCCESS, FETCH_ASSESSMENTS_FAILURE, UPDATE_LOADING_MESSAGE, UPDATE_SECTION_PROGRESS, DELETE_ASSESSMENT, UPDATE_CAUSE_FIELD, SAVE_RISK_SOURCE_START,
  SAVE_RISK_SOURCE_SUCCESS,
  SAVE_RISK_SOURCE_FAILURE,
  SAVE_CAUSES_START,
  SAVE_CAUSES_SUCCESS,
  SAVE_CAUSES_FAILURE, SET_CURRENT_SECTION,
  SET_CURRENT_SECTION_STEP,
  RESET_CURRENT_SECTION_STEP,
  REFINE_RISK_START,
  REFINE_RISK_SUCCESS,
  REFINE_RISK_FAILURE,
  ADD_MANUAL_RISK,
  SET_FIELD,
  SET_ROOT_CAUSE,
  SET_RISK_SOURCE,
  SET_DEEP_DIVE_DETAIL,
  SET_DEEP_DIVE_VALUES,
  GENERATE_RISK_NARRATIVE_START,
  GENERATE_RISK_NARRATIVE_SUCCESS,
  GENERATE_RISK_NARRATIVE_FAILURE,
  SELECT_RISK_SOURCE,
  DESELECT_RISK_SOURCE,
  REGISTER_RISK_SOURCES,
  TOGGLE_RISK_SOURCE,
  SET_RISK_SOURCE_PROGRESS,
  // New area-based actions
  SET_AREA_STATUS,
  SET_AREA_DEFERRED,
  SET_AREA_NOT_APPLICABLE,
  CLEAR_AREA_STATUS
} from './actionTypes'; 


//import riskForm from '../../riskForm.json'
//import { createAsyncThunk } from '@reduxjs/toolkit';
import { setSavedControls, fetchSavedControlEvaluations } from './controlActions';
import { fetchSecurityRisks, fetchSecurityControls, fetchScenarios } from './securityActions';
import { fetchContextData } from './contextActions';
import { fetchAllConfigs,fetchConfig } from './configActions';
import { fetchResidualRisk } from './residualRiskActions';
import { RiskFormGenerator } from '../selectors/riskFormGenerator.js';
// Explorer-specific imports
import {
  initializeExplorerAssessment,
  addExplorerRisk,
  addExplorerRisksBatch,
  updateExplorerAreaStatus,
  setExplorerAreaAnalysis,
  updateExplorerRiskPriority,
  EXPLORER_RISK_AREAS
} from '../slices/risksSlice';
//import _ from 'lodash';

/* ────────────────────────────────────────────────────────────── */
/*  Source-level progress for the new AssessmentStepperV2        */
/* ────────────────────────────────────────────────────────────── */




export const fetchAllModels = (token) => async (dispatch, getState) => {
  dispatch({ type: FETCH_ASSESSMENTS_START });
  dispatch(updateLoadingMessage('Initializing data fetch...'));

  try {
    // **Step 1: Fetch All Configuration Names**
    dispatch(updateLoadingMessage('Fetching all configuration names...'));
    await dispatch(fetchAllConfigs());

    const configState = getState().config;

    if (configState.error) {
      throw new Error(`Error fetching configurations: ${configState.error}`);
    }

    const configNames = configState.configNames;

    if (!configNames || configNames.length === 0) {
      throw new Error('No configuration names found.');
    }

    // **Step 2: Fetch Each Configuration Individually**
    dispatch(updateLoadingMessage('Fetching configuration data...'));
    await Promise.all(configNames.map(name => dispatch(fetchConfig(name))));

    // Check for any errors after fetching configurations
    if (configState.error) {
      throw new Error(`Error fetching configurations: ${configState.error}`);
    }
    dispatch(updateLoadingMessage('Preparing modelRisks data...'));
    const modelRisksData = RiskFormGenerator(getState());

    if (!modelRisksData || Object.keys(modelRisksData).length === 0) {
      throw new Error('modelRisksData is empty or undefined.');
    }

    // **Step 3: Fetch Models/Assessments**
    dispatch(updateLoadingMessage('Fetching assessments...'));
    const response = await authFetch('/.netlify/functions/FetchModelInventory', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const jsonResponse = await response.json();

    if (jsonResponse.success) {
      const models = jsonResponse.data;

      // **Step 4: Fetch Associated Data for Each Assessment**
      await Promise.all(models.map(async (model) => {
        const assessmentUuid = model.assessment_uuid;
        // Initialize assessment only if it does not exist in the state
        if (!getState().risks.byAssessment[assessmentUuid]) {
          dispatch({
            type: INITIALIZE_ASSESSMENT,
            payload: {
              assessmentUuid: assessmentUuid,
              modelId: model.model_uuid,
              modelName: model.model_name,
              modelType: model.model_type,
              modelStage: model.model_stage,
              useCaseShortDescription: model.use_case_short_description,
              created_at: model.created_at,
              created_by: model.created_by,
              avatar: model.avatar,
              createdByName: model.name,
              assessmentStatus: model.assessment_status,
              currentStep: model.current_step || 'Not Started',
              templateId: model.template_id,
              mode: model.mode,
              autonomous: model.autonomous,
              modelRisks: modelRisksData,
            },
          });
        }

        // === PARALLEL CALLS ===
        await Promise.all([
          (async () => {
            dispatch(updateLoadingMessage(`Fetching risk cards for ${model.model_name}...`));
            await dispatch(fetchRiskCardData(assessmentUuid, model.model_uuid));
          })(),

          (async () => {
            dispatch(updateLoadingMessage(`Fetching context for ${model.model_name}...`));
            await dispatch(fetchContextData(model.model_uuid, assessmentUuid));
          })(),

          (async () => {
            dispatch(updateLoadingMessage(`Fetching risks for ${model.model_name}...`));
            await dispatch(fetchAssessmentRisks(assessmentUuid, model.model_uuid));
            // Fetch evaluations after risks are loaded (sequential dependency)
            dispatch(updateLoadingMessage(`Fetching risk evaluations for ${model.model_name}...`));
            await dispatch(fetchAllAssessmentEvaluations(assessmentUuid, model.model_uuid));
          })(),

          // Sequential dependency: savedControls → controlEvaluations
          (async () => {
            dispatch(updateLoadingMessage(`Fetching action plans for ${model.model_name}...`));
            await dispatch(setSavedControls(model.model_uuid, assessmentUuid));
            await dispatch(fetchSavedControlEvaluations(model.model_uuid, assessmentUuid));
          })(),

          (async () => {
            dispatch(updateLoadingMessage(`Fetching residual risk for ${model.model_name}...`));
            await dispatch(fetchResidualRisk(assessmentUuid, model.model_uuid));
          })(),

          (async () => {
            dispatch(updateLoadingMessage(`Fetching assessment position for ${model.model_name}...`));
            await dispatch(fetchAssessmentPosition(model.model_uuid, assessmentUuid));
          })(),

          (async () => {
            dispatch(updateLoadingMessage(`Fetching security risks for ${model.model_name}...`));
            await dispatch(fetchSecurityRisks(model.model_uuid, assessmentUuid));
            const securityRisks = getState().security.models[model.model_uuid]?.securityRisks;
            if (securityRisks?.length) {
              dispatch(updateLoadingMessage(`Fetching security controls for ${model.model_name}...`));
              await Promise.all(
                securityRisks.map(risk =>
                  dispatch(fetchSecurityControls(model.model_uuid, risk.risk_id))
                )
              );
            }
          })(),

          (async () => {
            dispatch(updateLoadingMessage(`Fetching security scenarios for ${model.model_name}...`));
            await dispatch(fetchScenarios({ modelId: model.model_uuid, assessmentUuid }));
          })(),
        ]);
      }));

      dispatch({ type: FETCH_ASSESSMENTS_SUCCESS, payload: { models } });

      // Populate reviews state from models data
      const reviewsData = {};
      models.forEach(model => {
        if (model.review_status) {
          reviewsData[model.model_uuid] = {
            assessmentUuid: model.assessment_uuid,
            reviewStatus: model.review_status,
            requestedBy: {
              email: model.owner_email,
              name: model.owner_name,
              requestedAt: model.submitted_for_review_at
            },
            reviewedBy: model.reviewed_by ? {
              email: model.reviewed_by,
              reviewedAt: model.reviewed_at
            } : null,
            reviewResults: null
          };
        }
      });

      // Dispatch to reviews reducer
      dispatch({
        type: 'FETCH_REVIEWS_SUCCESS',
        payload: { reviews: reviewsData }
      });

      dispatch(updateLoadingMessage('Data fetch completed.'));
    } else {
      throw new Error('Failed to fetch assessments: ' + jsonResponse.message);
    }
  } catch (error) {
    console.error('Fetch assessments failed:', error);
    dispatch({ type: FETCH_ASSESSMENTS_FAILURE, payload: error.message });
    dispatch(updateLoadingMessage('Failed to load data.'));
  }
};
// Helper action to update loading message
const updateLoadingMessage = (message) => ({
  type: UPDATE_LOADING_MESSAGE,
  payload: message
});
export const deleteAssessmentAction = (assessmentUuid) => ({
  type: DELETE_ASSESSMENT,
  payload: assessmentUuid,
});

// Legacy alias for backward compatibility
export const deleteModelAction = deleteAssessmentAction;

/**
 * Sets the current assessment context for template-aware selectors
 * @param {string} modelId - The model UUID
 * @param {string} assessmentUuid - The assessment UUID
 * @param {string} templateId - The template UUID (optional, can be null for legacy assessments)
 */
export const setCurrentAssessment = (modelId, assessmentUuid, templateId = null, templateConfig = null) => ({
  type: SET_CURRENT_ASSESSMENT,
  payload: { modelId, assessmentUuid, templateId, templateConfig }
});

export const fetchAssessmentRisks = (assessmentUuid, modelId) => async (dispatch) => {
  dispatch({ type: FETCH_ASSESSMENT_RISKS_START, payload: { assessmentUuid } });
  try {
    const response = await authFetch('/.netlify/functions/fetchModelRisks', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ modelId, assessmentUuid })
    });
    const data = await response.json();

    console.log('assessment risks fetched and ready to be passed on to reducer', data.data);

    if (data.success) {
      dispatch({ type: FETCH_ASSESSMENT_RISKS_SUCCESS, payload: { assessmentUuid, risks: data.data } });
    } else {
      throw new Error(data.message || "Failed to fetch risks.");
    }
  } catch (error) {
    dispatch({ type: FETCH_ASSESSMENT_RISKS_FAILURE, payload: { assessmentUuid, error: error.message } });
  }
};

// Legacy alias for backward compatibility
export const fetchModelRisks = (modelId, assessmentUuid) => fetchAssessmentRisks(assessmentUuid, modelId);




// LEGACY - fetchRisksFromLLM is not used anywhere in the codebase (only in backups)
// export const fetchRisksFromLLM = (riskFormData, sectionName, activeSections,  sectionToUpdate, sectionsToFetch, modelId) => {
//   return async (dispatch) => {
//     dispatch(fetchRisksStart({ modelId, sectionsToFetch }));
//     try {
//         const body = {
//           riskFormData,
//           activeSections,
//           sectionsToFetch
//         };
//         console.log('body sent to fetch risks', body)
//         if (sectionToUpdate) {
//           body.sectionToUpdate = sectionToUpdate;
//         }
//
//         const response = await authFetch('/.netlify/functions/fetchRisksForSection', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(body),
//         });
//           if (!response.ok) {
//               throw new Error(`Error fetching risks: ${response.status} ${response.statusText}`);
//           }
//
//           const fetchedRisks = await response.json();
//           console.log('fetchedRisks:', fetchedRisks);
//           if (!Array.isArray(fetchedRisks)) {
//             throw new Error('Unexpected response format: fetchedRisks is not an array');
//           }
//           console.log('Dispatching fetchRisksFromLLM');
//           dispatch(fetchRisksSuccess(fetchedRisks, sectionsToFetch, modelId));
//       } catch (error) {
//           console.error('Fetch error:', error.message);
//           dispatch(fetchRisksFailure(error.message));
//       }
//   };
// };

// src/redux/actions/riskActions.js

export const generateRisksWithRAG = (assessmentUuid, sectionName, riskAreaData, risks, narratives) => async (dispatch, getState) => {
  const state = getState();
  const sectionData = state.risks.byAssessment[assessmentUuid]?.modelRisks[sectionName] || {};
  const existingRisks = state.risks.byAssessment[assessmentUuid]?.modelRisks[sectionName]?.areaRisks || {};

  const hasExistingRisks = Object.values(existingRisks)
    .flatMap(risksArray => risksArray)
    .some(risk => risk?.status === 'Saved');

  if (hasExistingRisks) {
    console.log('Existing risks found, skipping fetch.');
    return;  // Skip fetch if saved risks are found
  }

  dispatch({ type: FETCH_SECTION_SPECIFIC_RISKS_START, payload: { assessmentUuid, risks, sectionName } });

  try {
    const body = {
      sectionName,
      riskAreaData,
      risks,
      sectionData,
      narratives,
      useRAG: true // Indicate that RAG should be used
    };

    console.log('Request body for RAG-based risk generation:', body);

    const response = await authFetch('/.netlify/functions/generateRisksWithRAG', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch section-specific risks: ${response.status}`);
    }

    const fetchedRisks = await response.json();

    // Process the fetched risks to categorize them
    const categorizedRisks = fetchedRisks.reduce((acc, risk) => {
      const { category = 'Uncategorized' } = risk; // Default to 'Uncategorized' if no category
      if (!acc[category]) acc[category] = [];
      acc[category].push({
        ...risk,
        status: risk.status || 'Generated'  // Ensure each risk has a 'Generated' status if none is present
      });
      return acc;
    }, {});

    dispatch({
      type: FETCH_SECTION_SPECIFIC_RISKS_SUCCESS,
      payload: { assessmentUuid, sectionName, risks: categorizedRisks },
    });

  } catch (error) {
    console.error('Error fetching section-specific risks with RAG:', error);
    dispatch({
      type: FETCH_SECTION_SPECIFIC_RISKS_FAILURE,
      payload: { assessmentUuid, sectionName, error: error.message },
    });
  }
};


export const fetchNewRisks = (assessmentUuid, sectionName, riskAreaData, allRisks, narratives, sectionData) => async dispatch => {
  try {
    const response = await authFetch('/.netlify/functions/generateRisks', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        assessmentUuid,
        sectionName,
        riskAreaData,
        risks: allRisks,
        narratives,
        sectionData,
        useRAG: false
      }),
    });
    const newRisks = await response.json();
    console.log('received risks to refresh to dispatch', newRisks);

    // Process the new risks to categorize them
    const categorizedRisks = newRisks.reduce((acc, risk) => {
      const { category = 'Uncategorized' } = risk; // Fallback to 'Uncategorized' if no category
      if (!acc[category]) acc[category] = [];
      acc[category].push(risk);
      return acc;
    }, {});

    dispatch({ type: REFRESH_RISKS_SUCCESS, payload: { assessmentUuid, sectionName, categorizedRisks } });
  } catch (error) {
    console.error('Failed to fetch new risks:', error);
  }
};


export const refineRisk = ({
  assessmentUuid,
  sectionName,
  category,
  originalName,
  originalRiskText,
  userInstruction,
  context
}) => async dispatch => {
  dispatch({ type: REFINE_RISK_START, payload: { assessmentUuid } });
  try {
    const res = await authFetch('/.netlify/functions/refineRiskLLM', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        originalRiskText,
        userInstruction,
        context
      })
    });
    const { refinedRisk, rationale } = await res.json();

    dispatch({
      type: REFINE_RISK_SUCCESS,
      payload: {
        assessmentUuid,
        sectionName,
        category,
        originalName,
        refinedRisk,
        rationale
      }
    });
  } catch (err) {
    dispatch({ type: REFINE_RISK_FAILURE, payload: { assessmentUuid, error: err.message } });
  }
};



export const updateActiveSections = (assessmentUuid, sections) => {
  // Log the action payload before dispatching
  console.log('Dispatching updateActiveSections with:', { assessmentUuid, sections });

  return {
    type: 'risks/updateActiveSections',
    payload: { assessmentUuid, sections },
  };
};





// export const fetchRisksForModel = createAsyncThunk(
//   'risks/fetchRisksForModel',
//   async ({ modelId, assessmentUuid, sectionName }, { rejectWithValue }) => {
//     try {
//       if (!modelId || !assessmentUuid) {
//         throw new Error('Model ID or Assessment UUID is missing');
//       }
//       const response = await authFetch('/.netlify/functions/fetchRisks', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ modelId, assessmentUuid, sectionName }),
//       });
//       if (!response.ok) {
//         throw new Error(`Failed to fetch risks for model ${modelId} and assessment ${assessmentUuid} and section ${sectionName} `);
//       }
//       const fetchedRisks = await response.json();
//       console.log ('fetchedrisks from db to dispatch to reducer', fetchedRisks)
//       return fetchedRisks; 
//     } catch (error) {
//       console.error(`Error fetching risks for model ${modelId} and assessment ${assessmentUuid}:`, error);
//       return rejectWithValue(error.message); // This will be the payload for the rejected action
//     }
//   }
// );

export const setModelId = (
  modelId,
  modelName,
  modelType,
  modelStage,
  useCaseShortDescription,
  created_at,
  created_by,
  avatar,
  createdByName,
  assessmentUuid,
  assessmentStatus,
  currentStep,
  riskFormData,
  templateId = null,
  mode = null,
  autonomous = null,
  position = null,
  ownerName = null,
  ownerEmail = null,
  lastUpdatedByName = null,
  lastUpdatedByEmail = null,
  reviewStatus = null,
  updatedAt = null
) => ({
  type: SET_MODEL_ID,
  payload: {
    modelId,
    modelName,
    modelType,
    modelStage,
    useCaseShortDescription,
    created_at,
    created_by,
    avatar,
    createdByName,
    assessmentUuid,
    assessmentStatus,
    currentStep,
    riskFormData,
    templateId,
    mode,
    autonomous,
    position,
    ownerName,
    ownerEmail,
    lastUpdatedByName,
    lastUpdatedByEmail,
    reviewStatus,
    updatedAt
  },
});


// LEGACY - No reducer case handles FETCH_RISKS_SUCCESS
// export const fetchRisksSuccess = (fetchedRisks, sectionsToFetch, modelId) => ({
//   type: FETCH_RISKS_SUCCESS,
//   payload: { fetchedRisks, sectionsToFetch, modelId }
// });


export const fetchRisksFailure = (error, sectionName, modelId) => ({
  type: FETCH_RISKS_FAILURE,
  payload: { error, sectionName, modelId },
});

// LEGACY - No reducer case handles SAVE_SELECTED_RISKS
// export const saveSelectedRisks = (risks, assessmentUuid) => ({
//   type: SAVE_SELECTED_RISKS,
//   payload: { risks, assessmentUuid }
// });

export const discardRisk = (risk, assessmentUuid, sectionName) => ({
  type: DISCARD_RISKS,
  payload: { risk, assessmentUuid, sectionName }
});

export const discardUnselectedRisks = (risksToDiscard, assessmentUuid) => {
  return {
    type: DISCARD_UNSAVED_RISKS,
    payload: { risksToDiscard, assessmentUuid },
  };
};



export const setRiskPriority = (assessmentUuid, riskId, sectionName, category, riskName, numericThemeId, themeName, evaluationData, modelId) => {
  return async (dispatch) => {
    dispatch({
      type: SET_RISK_PRIORITY_START,
      payload: { assessmentUuid, sectionName, category, riskId },
    });
    try {
      const payload = JSON.stringify({
        riskName,
        themeName,
        evaluationData,
      });

      const response = await authFetch('/.netlify/functions/prioritizeRisks', {
        method: 'POST',
        body: payload,
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        throw new Error('HTTP error ' + response.statusText);
      }

      const data = await response.json();

      // Dispatch action to update Redux store
      dispatch({
        type: SET_RISK_PRIORITY_SUCCESS,
        payload: {
          assessmentUuid,
          riskId,
          sectionName,
          category,
          numericThemeId,
          themeName,
          priority: data.priority,
          rationale: data.rationale,
        },
      });

      // Save priority and rationale to the database
      const savePayload = {
        modelUuid: modelId,
        assessmentUuid,
        riskId,
        priority: data.priority,
        rationale: data.rationale,
      };

      const saveResponse = await authFetch('/.netlify/functions/saveRiskPriority', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(savePayload),
      });

      if (!saveResponse.ok) {
        throw new Error('Failed to save priority and rationale to database');
      }

      return Promise.resolve(); // Successfully resolved the promise
    } catch (error) {
      dispatch({
        type: SET_RISK_PRIORITY_FAILURE,
        payload: { assessmentUuid, sectionName, category, riskId, error: error.message },
      });
      return Promise.reject(error); // Reject the promise if there's an error
    }
  };
};


export const updateRiskPriority = (assessmentUuid, riskId, sectionName, category, priority, modelId, rationale = '') => {
  return async (dispatch) => {
    // Dispatch action to update Redux store
    dispatch({
      type: UPDATE_RISK_PRIORITY,
      payload: { assessmentUuid, riskId, sectionName, category, priority },
    });

    // Save updated priority to the database
    try {
      const savePayload = {
        modelUuid: modelId,
        assessmentUuid,
        riskId,
        priority,
        rationale: rationale || '', // Use passed rationale parameter
      };

      const saveResponse = await authFetch('/.netlify/functions/saveRiskPriority', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(savePayload),
      });

      if (!saveResponse.ok) {
        throw new Error('Failed to save updated priority to database');
      }

      // Dispatch success action to update Redux with rationale
      dispatch({
        type: SET_RISK_PRIORITY_SUCCESS,
        payload: { assessmentUuid, riskId, sectionName, category, priority, rationale }
      });

    } catch (error) {
      console.error('Error saving updated priority:', error);
    }
  };
};

export const setSection = (sectionName, assessmentUuid) => ({
  type: SET_SECTION,
  payload: { sectionName, assessmentUuid }
});
export const setCurrentSection = (assessmentUuid, sectionName) => ({
  type: SET_CURRENT_SECTION,
  payload: { assessmentUuid, sectionName },
});

// Action to set the current step within a section
export const setCurrentSectionStep = (assessmentUuid, stepName) => ({
  type: SET_CURRENT_SECTION_STEP,
  payload: { assessmentUuid, stepName },
});

// Action to reset the current step (useful when changing sections)
export const resetCurrentSectionStep = (assessmentUuid) => ({
  type: RESET_CURRENT_SECTION_STEP,
  payload: { assessmentUuid },
});


export const setStep = (assessmentUuid, sectionName, stepName) => ({
  type: SET_STEP,
  payload: { assessmentUuid, sectionName, stepName }
});

// Redux Action
export const updateAssessmentStep = (assessmentUuid, modelId, step) => async (dispatch) => {
  try {
    const response = await authFetch('/.netlify/functions/manageAssessment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modelId, assessmentUuid, currentStep: step, operation: 'update' }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to update step');
    dispatch({
      type: UPDATE_ASSESSMENT_STEP_SUCCESS,
      payload: { assessmentUuid, currentStep: step }
    });
  } catch (error) {
    console.error('Error updating step:', error);
  }
};

export const setAssessmentPosition =
  (modelId, assessmentUuid, position) => async dispatch => {
    try {
      // Update database first
      const response = await authFetch('/.netlify/functions/manageAssessment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          modelId,
          assessmentUuid,
          operation: 'update',
          position
        })
      });

      if (!response.ok) {
        throw new Error(`Failed to update position: ${response.status}`);
      }

      // Only update Redux state after successful database update
      dispatch({ type: SET_ASSESSMENT_POSITION, payload: { assessmentUuid, position } });
    } catch (err) {
      console.error('Failed to persist assessment position', err);
      // Don't update Redux state if database update failed
    }
  };

export const fetchAssessmentPosition =
  (modelId, assessmentUuid) => async dispatch => {
    try {
      const response = await authFetch('/.netlify/functions/manageAssessment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          modelId,
          assessmentUuid,
          operation: 'get_position'
        })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.position) {
          dispatch({ type: SET_ASSESSMENT_POSITION, payload: { assessmentUuid, position: data.position } });
        }
      }
    } catch (err) {
      console.error('Failed to fetch assessment position', err);
    }
  };

// LEGACY - No reducer case handles SET_RISKS
// export const setRisks = (risks) => ({
//     type: SET_RISKS,
//     payload: risks
// });

// LEGACY - No reducer case handles TOGGLE_SELECTED_THEME
// export const toggleSelectedTheme = (theme) => ({
//     type: TOGGLE_SELECTED_THEME,
//     payload: theme
// });

// LEGACY - No reducer case handles HANDLE_SELECTED_RISKS_UPDATE
// export const handleSelectedRisksUpdate = (selectedRisk, assessmentUuid) => {
//   return {
//     type: HANDLE_SELECTED_RISKS_UPDATE,
//     payload: { selectedRisk, assessmentUuid }
//   };
// };

// LEGACY - No reducer case handles UPDATE_RISKS_AFTER_SELECTION
// export const updateRisksAfterSelection = (updatedRisks) => {
//   return {
//       type: UPDATE_RISKS_AFTER_SELECTION,
//       payload: updatedRisks,
//   };
// };

export const fetchRisksStart = ({ assessmentUuid, sectionsToFetch }) => ({
  type: FETCH_RISKS_START,
  payload: { assessmentUuid, sectionsToFetch },
});


// Risk evaluation actions - assessmentUuid is now the primary key

export const setRiskEvaluation = (
  assessmentUuid,
  riskId,
  themeId,
  evaluationData,
  sectionName,
  category
) => ({
  type: SET_RISK_EVALUATION,
  payload: { assessmentUuid, riskId, themeId, evaluationData, sectionName, category }
});

export const updateRiskEvaluation = (assessmentUuid, riskId, sectionName, themeId, attribute, property, value, priority, rationale, category) => ({
  type: UPDATE_RISK_EVALUATION,
  payload: { assessmentUuid, riskId, sectionName, themeId, attribute, property, value, priority, rationale, category }
});


// Action to update the name of a risk that hasn't been saved to the backend yet
export const updateRiskName = (assessmentUuid, sectionName, category, originalName, newName) => ({
  type: UPDATE_RISK_NAME,
  payload: { assessmentUuid, sectionName, category, originalName, newName }
});


export const updateRiskWithControls = (assessmentUuid, riskName, controlData) => dispatch => {
  dispatch({
    type: UPDATE_CONTROL_IN_SELECTED_RISK,
    payload: { assessmentUuid, riskName, controlData },
  });
};

// Add manual risk action creator
export const addManualRisk = (assessmentUuid, sectionName, riskName, category) => ({
  type: ADD_MANUAL_RISK,
  payload: { assessmentUuid, sectionName, category, riskName }
});
export const fetchRiskCardDataStart = (assessmentUuid) => ({
  type: FETCH_RISK_CARD_DATA_START,
  payload: { assessmentUuid },
});

// Action creator for a successful fetch operation
export const fetchRiskCardDataSuccess = (data, assessmentUuid) => ({
  type: FETCH_RISK_CARD_DATA_SUCCESS,
  payload: { data, assessmentUuid },
});

// Action creator for a failed fetch operation
export const fetchRiskCardDataFailure = (error, assessmentUuid) => ({
  type: FETCH_RISK_CARD_DATA_FAILURE,
  payload: { error, assessmentUuid },
});

export const setField = ({ assessmentUuid, section, source, valueKey, path, newValue }) => ({
  type: SET_FIELD,
  payload: { assessmentUuid, section, source, valueKey, path, newValue }
});

/** Select which source-values are active */
export const setRiskSource = ({ assessmentUuid, section, source, values }) => ({
  type: SET_RISK_SOURCE,
  payload: { assessmentUuid, section, source, values }
});

/** Update one field deep inside the causes blob */
export const setRootCause = ({ assessmentUuid, section, source, valueKey, path, newValue }) => ({
  type: SET_ROOT_CAUSE,
  payload: { assessmentUuid, section, source, valueKey, path, newValue }
});

export const setDeepDiveValues = ({ assessmentUuid, section, source, valueKey, causeCategory, deepValues }) => ({
  type: SET_DEEP_DIVE_VALUES,
  payload: { assessmentUuid, section, source, valueKey, causeCategory, deepValues }
});

export const setDeepDiveDetail = ({ assessmentUuid, section, source, valueKey, causeCategory, option, detail }) => ({
  type: SET_DEEP_DIVE_DETAIL,
  payload: { assessmentUuid, section, source, valueKey, causeCategory, option, detail }
});

/* ---------- thunk ----------------------------------------------- */
/**
 * Fetch risk‑card data (sources + causes) for an assessment.
 * The Netlify function may return either:
 *   • an *array* of flattened rows   (legacy),
 *   • OR an *object* grouped by riskArea (Flow‑v2).
 * We normalise to the grouped‑object shape before dispatching.
 */
export const fetchRiskCardData =
  (assessmentUuid, modelId) => async dispatch => {
    dispatch({
      type: FETCH_RISK_CARD_DATA_START,
      payload: { assessmentUuid }
    });

    try {
      const res = await authFetch('/.netlify/functions/fetchRiskCard', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model_uuid: modelId,
          assessment_uuid: assessmentUuid,
        }),
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(`API ${res.status}: ${txt}`);
      }

      const apiData = await res.json();

      /* ---------- normalise ---------- */
      let groupedData;
      if (Array.isArray(apiData)) {
        // Legacy flat rows -> regroup
        groupedData = apiData.reduce((acc, row) => {
          const area = row.risk_area;
          acc[area] = acc[area] || [];

          const isSentinel = row.source_value === row.risk_source;
          const card = {
            name: row.risk_source,
            value: isSentinel ? [] : [row.source_value],
            causes: isSentinel ? (row.causes || {}) : {},
            selected: true,
            causesByValue: isSentinel
              ? {}
              : { [row.source_value]: row.causes || {} },
          };

          acc[area].push(card);
          return acc;
        }, {});
      } else {
        // Flow‑v2 payload is already grouped
        groupedData = apiData;
      }

      dispatch({
        type: FETCH_RISK_CARD_DATA_SUCCESS,
        payload: { assessmentUuid, fetchedData: groupedData },
      });
    } catch (err) {
      console.error('[fetchRiskCardData]', err);
      dispatch({
        type: FETCH_RISK_CARD_DATA_FAILURE,
        payload: { assessmentUuid, error: err.message },
      });
    }
  };




export const updateCauseField = (assessmentUuid, sectionName, riskSource, causeCategory, value) => ({
  type: UPDATE_CAUSE_FIELD,
  payload: { assessmentUuid, sectionName, riskSource, causeCategory, value },
});

export const saveRiskSource = (riskSourceData) => async (dispatch) => {
  dispatch({ type: SAVE_RISK_SOURCE_START });

  try {
    const response = await authFetch('/.netlify/functions/saveRiskSource', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(riskSourceData),
    });

    const result = await response.json();

    if (result.success) {
      dispatch({ type: SAVE_RISK_SOURCE_SUCCESS, payload: result.message });
    } else {
      dispatch({ type: SAVE_RISK_SOURCE_FAILURE, payload: result.message });
    }
  } catch (error) {
    dispatch({ type: SAVE_RISK_SOURCE_FAILURE, payload: error.message });
  }
};

// Save Causes Action
export const saveCauses = (causesData) => async (dispatch) => {
  dispatch({ type: SAVE_CAUSES_START });

  try {
    const response = await authFetch('/.netlify/functions/saveCauses', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(causesData),
    });

    const result = await response.json();

    if (result.success) {
      dispatch({ type: SAVE_CAUSES_SUCCESS, payload: result.message });
    } else {
      dispatch({ type: SAVE_CAUSES_FAILURE, payload: result.message });
    }
  } catch (error) {
    dispatch({ type: SAVE_CAUSES_FAILURE, payload: error.message });
  }
};



export const fetchRiskEvaluations = (
  assessmentUuid,
  modelId,
  riskArea,
  category
) => async (dispatch, getState) => {
  // Indicate we're starting the fetch
  dispatch({ type: FETCH_RISK_EVALUATIONS, payload: { assessmentUuid } });

  try {
    // Hit the netlify function
    const response = await authFetch('/.netlify/functions/fetchRiskEvaluation', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modelId, assessmentUuid, riskArea }),
    });

    if (!response.ok) {
      throw new Error(`Network response was not ok, status: ${response.status}`);
    }

    const data = await response.json();
    console.log('data into fetch riskeval', data);

    if (!Array.isArray(data.evaluations)) {
      throw new Error('Expected an array of evaluations, but did not receive one.');
    }

    // Get config from current state
    const currentState = getState();
    const riskEvaluationForm = currentState.config?.configs?.riskEvaluationForm || [];

    dispatch({
      type: FETCH_RISK_EVALUATIONS_SUCCESS,
      payload: {
        assessmentUuid,
        evaluations: data.evaluations,
        sectionName: riskArea,
        category,
        riskEvaluationForm
      },
    });
  } catch (error) {
    console.error('Error fetching risk evaluations:', error);
    dispatch({
      type: FETCH_RISK_EVALUATIONS_FAILURE,
      payload: { assessmentUuid, error: error.toString(), riskArea, category }
    });
  }
};

export const moveRiskToSaved = (assessmentUuid, sectionName, risk) => ({
  type: MOVE_RISK_TO_SAVED,
  payload: { assessmentUuid, sectionName, risk }
});

export const updateSavedRisk = (assessmentUuid, riskId, sectionName, category, newDetails) => ({
  type: UPDATE_SAVED_RISK,
  payload: { assessmentUuid, riskId, sectionName, category, newDetails }
});

export const discardSavedRisk = (riskId, assessmentUuid, sectionName) => ({
  type: DISCARD_SAVED_RISK,
  payload: { riskId, assessmentUuid, sectionName }
});


export const resetRisksState = () => ({
  type: RESET_RISKS_STATE
});

export const fetchSectionSpecificRisks = (assessmentUuid, sectionName, riskAreaData, risks, narratives) => async (dispatch, getState) => {
  const state = getState();
  const existingRisks = state.risks.byAssessment[assessmentUuid]?.modelRisks[sectionName]?.areaRisks || {};

  const hasExistingRisks = Object.values(existingRisks)
    .flatMap(risksArray => risksArray)
    .some(risk => risk?.status === 'Saved');

  if (hasExistingRisks) {
    console.log('Existing risks found, skipping fetch.');
    return;
  }

  dispatch({ type: FETCH_SECTION_SPECIFIC_RISKS_START, payload: { assessmentUuid, sectionName } });

  try {
    const response = await authFetch('/.netlify/functions/generateRisks', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sectionName, riskAreaData, risks, narratives }),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch section-specific risks: ${response.status}`);
    }

    const fetchedRisks = await response.json();

    // Process the fetched risks to categorize them
    const categorizedRisks = fetchedRisks.reduce((acc, risk) => {
      const { category = 'Uncategorized' } = risk;
      if (!acc[category]) acc[category] = [];
      acc[category].push({
        ...risk,
        status: risk.status || 'Generated'
      });
      return acc;
    }, {});

    dispatch({
      type: FETCH_SECTION_SPECIFIC_RISKS_SUCCESS,
      payload: { assessmentUuid, sectionName, risks: categorizedRisks },
    });

  } catch (error) {
    console.error('Error fetching section-specific risks:', error);
    dispatch({
      type: FETCH_SECTION_SPECIFIC_RISKS_FAILURE,
      payload: { assessmentUuid, sectionName, error: error.message },
    });
  }
};


export const updateAssessmentStatus = (modelId, assessmentUuid, assessmentStatus) => async (dispatch) => {

  console.log(`Attempting to update status: ${assessmentStatus} for assessment ${assessmentUuid}`);

  try {
    const response = await authFetch('/.netlify/functions/manageAssessment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modelId, assessmentUuid, operation: 'updateStatus', assessmentStatus })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error);

    console.log('status received from database', data);
    dispatch(assessmentStatusUpdated(assessmentUuid, data.assessmentStatus));
  } catch (error) {
    console.error('Failed to update assessment status:', error);
    dispatch(assessmentStatusFailed(assessmentUuid, error.toString()));
  }
};


export const assessmentStatusUpdated = (assessmentUuid, assessmentStatus) => ({
  type: ASSESSMENT_STATUS_UPDATED,
  payload: { assessmentUuid, assessmentStatus }
});

export const assessmentStatusFailed = (assessmentUuid, error) => ({
  type: ASSESSMENT_STATUS_FAILED,
  payload: { assessmentUuid, error }
});
export const updateSectionProgress = (assessmentUuid, sectionName, progress) => ({
  type: UPDATE_SECTION_PROGRESS,
  payload: { assessmentUuid, sectionName, progress }
});

export const generateRiskNarrative = (assessmentUuid, riskCard, modelContext) => async dispatch => {
  dispatch({ type: GENERATE_RISK_NARRATIVE_START, payload: { assessmentUuid, riskId: riskCard.id } });
  try {
    const res = await authFetch('/.netlify/functions/generateRiskNarrative', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ card: riskCard, modelContext })
    });
    if (!res.ok) throw new Error(res.statusText);
    const { narrative } = await res.json();
    dispatch({
      type: GENERATE_RISK_NARRATIVE_SUCCESS,
      payload: { assessmentUuid, riskId: riskCard.id, narrative }
    });
  } catch (err) {
    dispatch({
      type: GENERATE_RISK_NARRATIVE_FAILURE,
      payload: { assessmentUuid, riskId: riskCard.id, error: err.message }
    });
  }
};

/**
 * Persist a newly‑selected risk source.
 *   • Writes to local store via SELECT_RISK_SOURCE elsewhere.
 *   • Persists to the DB through /.netlify/functions/saveRiskSource.
 *   • Refreshes the local cache afterwards.
 *
 *  NOTE: We keep `values:[riskName]` for future catalogue refinement.
 */
export const createRiskFromSource = (
  modelId,
  assessmentUuid,
  riskArea,
  riskName
) => async dispatch => {
  try {
    // Step 1: persist to DB (sentinel row pattern)
    await dispatch(
      saveRiskSource({
        modelId,
        assessmentUuid,
        risk_area  : riskArea,
        risk_source: riskName,
        values     : [riskName],
      })
    );

    // Step 2: refresh local cache so fetchRiskCardData reflects DB
    await dispatch(fetchRiskCardData(modelId, assessmentUuid));
  } catch (err) {
    /* eslint-disable no-console */
    console.error('Error saving new risk source:', err);
    /* eslint-enable  */
  }
};

// ──────────────────────────────────────────────────────────
// Single‑risk flow — select / deselect a source card
export const selectRiskSource = (assessmentUuid, riskArea, src) => ({
  type: SELECT_RISK_SOURCE,
  payload: { assessmentUuid, riskArea, src },
});

export const deselectRiskSource = (assessmentUuid, riskArea, srcName) => ({
  type: DESELECT_RISK_SOURCE,
  payload: { assessmentUuid, riskArea, srcName },
});
/**
 * Initialise the list of possible sources for a given risk-area.
 * @param {string} assessmentUuid
 * @param {string} riskArea   canonical key (e.g. "dataQuality")
 * @param {string[]} names    full canonical list of source names
 */
export const registerRiskSources = (assessmentUuid, riskArea, names) => ({
  type: REGISTER_RISK_SOURCES,
  payload: { assessmentUuid, riskArea, names },
});

/**
 * Toggle (select/unselect) a single source inside the "Select Sources" screen.
 */
export const toggleRiskSource = (assessmentUuid, riskArea, srcName) => ({
  type: TOGGLE_RISK_SOURCE,
  payload: { assessmentUuid, riskArea, srcName },
});

/**
 * Persist % progress as the mini-wizard advances (0-100).
 */
export const setRiskSourceProgress = (assessmentUuid, riskArea, srcName, progress) => ({
  type: SET_RISK_SOURCE_PROGRESS,
  payload: { assessmentUuid, riskArea, srcName, progress },
});

// ──────────────────────────────────────────────────────────
// New area-based status management actions
// ──────────────────────────────────────────────────────────

/**
 * Set general area status (active, deferred, not_applicable, completed)
 */
export const setAreaStatus = (assessmentUuid, areaName, status, modelId) => async dispatch => {
  dispatch({
    type: SET_AREA_STATUS,
    payload: { assessmentUuid, areaName, status }
  });

  // Persist to database via manageAssessment
  try {
    await authFetch('/.netlify/functions/manageAssessment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelId,
        assessmentUuid,
        operation: 'updateAreaStatus',
        areaName,
        status
      })
    });
  } catch (error) {
    console.error('Failed to persist area status:', error);
  }
};

/**
 * Mark area as deferred (save for later)
 */
export const setAreaDeferred = (assessmentUuid, areaName, modelId) => async dispatch => {
  dispatch({
    type: SET_AREA_DEFERRED,
    payload: { assessmentUuid, areaName }
  });

  // Persist to database
  try {
    await authFetch('/.netlify/functions/manageAssessment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelId,
        assessmentUuid,
        operation: 'updateAreaStatus',
        areaName,
        status: 'DEFERRED'
      })
    });
  } catch (error) {
    console.error('Failed to persist deferred status:', error);
  }
};

/**
 * Mark area as not applicable
 */
export const setAreaNotApplicable = (assessmentUuid, areaName, modelId) => async dispatch => {
  dispatch({
    type: SET_AREA_NOT_APPLICABLE,
    payload: { assessmentUuid, areaName }
  });

  // Persist to database
  try {
    await authFetch('/.netlify/functions/manageAssessment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelId,
        assessmentUuid,
        operation: 'updateAreaStatus',
        areaName,
        status: 'NA'
      })
    });
  } catch (error) {
    console.error('Failed to persist not applicable status:', error);
  }
};

/**
 * Mark area as complete
 */
export const setAreaComplete = (assessmentUuid, areaName, modelId) => async dispatch => {
  dispatch({
    type: SET_AREA_STATUS,
    payload: { assessmentUuid, areaName, status: 'Complete' }
  });

  // Persist to database
  try {
    await authFetch('/.netlify/functions/manageAssessment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelId,
        assessmentUuid,
        operation: 'updateAreaStatus',
        areaName,
        status: 'Complete'
      })
    });
  } catch (error) {
    console.error('Failed to persist area completion status:', error);
  }
};

/**
 * Clear area status (re-enable for assessment)
 */
export const clearAreaStatus = (assessmentUuid, areaName, modelId) => async dispatch => {
  dispatch({
    type: CLEAR_AREA_STATUS,
    payload: { assessmentUuid, areaName }
  });

  // Persist to database
  try {
    await authFetch('/.netlify/functions/manageAssessment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelId,
        assessmentUuid,
        operation: 'updateAreaStatus',
        areaName,
        status: null // Clear the status
      })
    });
  } catch (error) {
    console.error('Failed to clear area status:', error);
  }
};

// Fetch all risk evaluations for an assessment (used during application startup)
export const fetchAllAssessmentEvaluations = (assessmentUuid, modelId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const assessmentData = state.risks.byAssessment[assessmentUuid];

    if (!assessmentData || !assessmentData.modelRisks) {
      console.log(`[fetchAllAssessmentEvaluations] No modelRisks data for assessment ${assessmentUuid}`);
      return;
    }

    // Get all risk areas and their categories from the assessment's modelRisks
    const evaluationPromises = [];

    Object.keys(assessmentData.modelRisks).forEach(riskArea => {
      const areaData = assessmentData.modelRisks[riskArea];
      if (areaData.areaRisks) {
        Object.keys(areaData.areaRisks).forEach(category => {
          // Only fetch if there are actual risks in this category
          const risks = areaData.areaRisks[category];
          if (risks && risks.length > 0) {
            console.log(`[fetchAllAssessmentEvaluations] Fetching evaluations for ${riskArea}/${category}`);
            evaluationPromises.push(
              dispatch(fetchRiskEvaluations(assessmentUuid, modelId, riskArea, category))
            );
          }
        });
      }
    });

    if (evaluationPromises.length > 0) {
      console.log(`[fetchAllAssessmentEvaluations] Fetching ${evaluationPromises.length} evaluation sets for assessment ${assessmentUuid}`);
      await Promise.all(evaluationPromises);
      console.log(`[fetchAllAssessmentEvaluations] Completed fetching all evaluations for assessment ${assessmentUuid}`);
    } else {
      console.log(`[fetchAllAssessmentEvaluations] No evaluations to fetch for assessment ${assessmentUuid}`);
    }
  } catch (error) {
    console.error(`[fetchAllAssessmentEvaluations] Error fetching evaluations for assessment ${assessmentUuid}:`, error);
  }
};

// Legacy alias for backward compatibility
export const fetchAllModelEvaluations = (modelId, assessmentUuid) => fetchAllAssessmentEvaluations(assessmentUuid, modelId);

// ============================================================================
// Explorer-Specific Thunks
// ============================================================================

/**
 * Fetch Explorer risks from the database for an assessment
 * Explorer risks are stored in the same `risks` table but with different assessment_uuid
 */
export const fetchExplorerRisks = (assessmentUuid, modelId) => async (dispatch, getState) => {
  try {
    console.log('[fetchExplorerRisks] Fetching for assessment:', assessmentUuid);

    // Initialize the Explorer structure first
    dispatch(initializeExplorerAssessment({ assessmentUuid, areas: EXPLORER_RISK_AREAS }));

    const response = await authFetch('/.netlify/functions/fetchModelRisks', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelId,
        assessmentUuid,
        assessmentType: 'explorer' // Backend filter for Explorer risks
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: Failed to fetch Explorer risks`);
    }

    const data = await response.json();
    const risks = data.data || [];

    console.log('[fetchExplorerRisks] Fetched', risks.length, 'Explorer risks');

    // Group risks by area and dispatch batch adds
    const risksByArea = {};
    risks.forEach((risk) => {
      const areaKey = risk.active_section || 'commercialRisk';
      if (!risksByArea[areaKey]) risksByArea[areaKey] = [];

      risksByArea[areaKey].push({
        category: risk.category || 'Uncategorized',
        risk: {
          riskId: risk.risk_id,
          riskName: risk.risk_name,
          category: risk.category,
          priority: risk.priority,
          rationale: risk.rationale,
          status: 'Saved',
          type: risk.risk_type || 'Explorer',
          impactFactors: risk.impact_factors || [],
          owner: {
            name: risk.owner_name || 'Unknown',
            email: risk.owner_email || 'Unknown',
            picture: risk.owner_picture || 'https://via.placeholder.com/150'
          }
        }
      });
    });

    // Dispatch batch adds for each area
    Object.entries(risksByArea).forEach(([areaKey, areaRisks]) => {
      dispatch(addExplorerRisksBatch({ assessmentUuid, areaKey, risks: areaRisks }));
    });

    return { assessmentUuid, risks };
  } catch (error) {
    console.error('[fetchExplorerRisks] Error:', error);
    throw error;
  }
};

/**
 * Generate risks for an Explorer area using the backend AI endpoints
 */
export const generateExplorerAreaRisks = ({
  assessmentUuid,
  modelId,
  areaKey,
  areaDefinition,
  parentAssessmentUuid,
  narrative,
  businessContext
}) => async (dispatch) => {
  try {
    console.log('[generateExplorerAreaRisks] Generating for area:', areaKey);

    dispatch(updateExplorerAreaStatus({ assessmentUuid, areaKey, status: 'in_progress' }));

    const response = await authFetch('/.netlify/functions/explorerGenerateScenariosWithRAG', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelId,
        assessmentUuid,
        areaKey,
        areaDefinition,
        parentAssessmentUuid,
        narrative,
        businessContext
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: Failed to generate Explorer risks`);
    }

    const data = await response.json();
    const generatedRisks = data.risks || [];

    console.log('[generateExplorerAreaRisks] Generated', generatedRisks.length, 'risks for', areaKey);

    // Add generated risks to Redux
    const risksToAdd = generatedRisks.map((risk) => ({
      category: risk.category || areaDefinition?.label || 'General',
      risk: {
        riskName: risk.riskName || risk.risk_name,
        rationale: risk.rationale,
        status: 'Generated',
        type: 'Explorer',
        stakeholders: risk.stakeholders || [],
        businessImpact: risk.businessImpact || ''
      }
    }));

    dispatch(addExplorerRisksBatch({ assessmentUuid, areaKey, risks: risksToAdd }));

    // Set area analysis if provided
    if (data.areaAnalysis) {
      dispatch(setExplorerAreaAnalysis({
        assessmentUuid,
        areaKey,
        analysis: data.areaAnalysis
      }));
    }

    return { areaKey, risks: generatedRisks };
  } catch (error) {
    console.error('[generateExplorerAreaRisks] Error:', error);
    dispatch(updateExplorerAreaStatus({ assessmentUuid, areaKey, status: 'pending' }));
    throw error;
  }
};

/**
 * Save an Explorer risk to the database
 */
export const saveExplorerRisk = ({
  assessmentUuid,
  modelId,
  areaKey,
  risk
}) => async (dispatch) => {
  try {
    console.log('[saveExplorerRisk] Saving risk:', risk.riskName);

    const payload = {
      modelId,
      assessmentUuid,
      riskId: risk.riskId,
      riskName: risk.riskName,
      category: risk.category,
      activeSection: areaKey,
      riskType: 'Explorer',
      rationale: risk.rationale || '',
      priority: risk.priority || null,
      impactFactors: risk.impactFactors || [],
      stakeholders: risk.stakeholders || [],
      businessImpact: risk.businessImpact || ''
    };

    const response = await authFetch('/.netlify/functions/saveRisks', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: Failed to save Explorer risk`);
    }

    const data = await response.json();

    // Update the risk in Redux to Saved status
    dispatch(addExplorerRisk({
      assessmentUuid,
      areaKey,
      category: risk.category,
      risk: {
        ...risk,
        riskId: data.riskId || risk.riskId,
        status: 'Saved'
      }
    }));

    return data;
  } catch (error) {
    console.error('[saveExplorerRisk] Error:', error);
    throw error;
  }
};

/**
 * Set priority for an Explorer risk using the backend AI prioritization
 */
export const setExplorerRiskPriority = ({
  assessmentUuid,
  modelId,
  areaKey,
  category,
  riskId,
  riskName,
  evaluationData,
  parentAssessmentUuid,
  businessContext,
  stakeholders
}) => async (dispatch) => {
  try {
    console.log('[setExplorerRiskPriority] Setting priority for:', riskName);

    const response = await authFetch('/.netlify/functions/explorerPrioritizeRisks', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        riskName,
        areaName: areaKey,
        evaluationData,
        assessmentUuid,
        parentAssessmentUuid,
        businessContext,
        stakeholders
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: Failed to prioritize Explorer risk`);
    }

    const data = await response.json();

    // Update Redux with the priority
    dispatch(updateExplorerRiskPriority({
      assessmentUuid,
      areaKey,
      category,
      riskId,
      priority: data.priority,
      rationale: data.rationale,
      impactFactors: data.impactFactors || []
    }));

    // Save priority to database
    await authFetch('/.netlify/functions/saveRiskPriority', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelUuid: modelId,
        assessmentUuid,
        riskId,
        priority: data.priority,
        rationale: data.rationale
      })
    });

    return data;
  } catch (error) {
    console.error('[setExplorerRiskPriority] Error:', error);
    throw error;
  }
};

/**
 * Mark an Explorer area as complete
 */
export const completeExplorerArea = ({
  assessmentUuid,
  modelId,
  areaKey
}) => async (dispatch) => {
  dispatch(updateExplorerAreaStatus({ assessmentUuid, areaKey, status: 'completed' }));

  // Persist to database
  try {
    await authFetch('/.netlify/functions/manageAssessment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelId,
        assessmentUuid,
        operation: 'updateAreaStatus',
        areaName: areaKey,
        status: 'completed'
      })
    });
  } catch (error) {
    console.error('[completeExplorerArea] Failed to persist:', error);
  }
};
